import React, { memo } from 'react';
import { TOnChangeCheckbox } from 'common/types/common/onChangeCheckbox';
import { IListItem } from 'common/types/common/listItem';
import { IFilterSettings } from 'common/constants/types/filterSettings';

import Item from './Item';

const CheckboxList = ({
  items,
  onChange,
  state
}: CheckboxListProps) => (
  <>
    {items.map(({
      key,
      value,
      icon,
      iconColor,
      subtitle
    }) => (
      <Item
        key={key}
        itemKey={key}
        title={value}
        icon={icon}
        iconColor={iconColor}
        onChange={onChange}
        state={state}
        subtitle={subtitle}
      />
    ))}
  </>
);

interface IState {
  [key: string]: boolean;
};

export interface IItem extends IListItem, IFilterSettings {
  subtitle?: string;
}

export interface CheckboxListProps {
  items: IItem[];
  onChange?: TOnChangeCheckbox;
  state: IState;
};

export default memo(CheckboxList);
